export default "__VITE_ASSET__e9f8a1cb__"